import Image from "next/image";

export default function ExpertCard({ author }) {
  const name = author?.name || "InvoiceAce Editorial";
  const role = author?.role || "Invoicing & Small Business";
  const avatar = author?.avatar || "/blog/avatar-default.png";
  const bio = author?.bio || "We research practical ways to speed up payments and keep your brand consistent across invoices.";

  return (
    <aside className="rounded-xl border border-neutral-200 bg-white shadow-sm p-4 md:p-5">
      <div className="flex items-center gap-3 mb-3">
        <div className="relative w-10 h-10 rounded-full overflow-hidden ring-1 ring-neutral-200">
          <Image src={avatar} alt={name} fill sizes="40px" className="object-cover bg-neutral-100" onError={e => { e.target.src = "/blog/avatar-default.png"; }} />
        </div>
        <div>
          <p className="text-sm font-semibold text-neutral-900">{name}</p>
          <p className="text-xs text-neutral-600">{role}</p>
        </div>
      </div>
      <p className="text-sm text-neutral-700">{bio}</p>
    </aside>
  );
}
